import React from "react";
import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import "./Alert.css";

const Alert = ({ message, type = "info", onClose }) => {
  if (!message) return null;

  const isSuccess = message.includes('succès') || type === "success";
  const isError = message.includes('Erreur') || message.includes('Impossible') || type === "error";
  
  const alertType = isSuccess ? "success" : isError ? "destructive" : "info";
  const icon = isSuccess ? <CheckCircle size={20} weight="duotone" /> : <WarningCircle size={20} weight="duotone" />;
  const title = isSuccess ? "Succès !" : isError ? "Erreur" : "Information";

  return (
    <div className={`alert alert-${alertType}`} role="alert">
      <div className="alert-icon">{icon}</div>
      <div className="alert-content">
        <div className="alert-title">{title}</div>
        <div className="alert-description">{message}</div>
      </div>
      {onClose && (
        <button className="alert-close" onClick={onClose} aria-label="Fermer">
          ×
        </button>
      )}
    </div>
  );
};

export default Alert; 